import { XeroDisabledLogo } from '@approvalmax/ui';
import { Box, Flex, Text } from '@approvalmax/ui/src/components';

import { messages } from './XeroIntegrationDisconnectedNotice.messages';

export const XeroIntegrationDisconnectedNotice = () => {
    return (
        <Box bordered spacing='8' color='red20' radius='xsmall' borderColor='red60'>
            <Flex spacing='8' alignItems='center'>
                <XeroDisabledLogo width={28} height={28} />

                <Flex grow={1}>
                    <Text font='label' fontSize='medium' color='red100'>
                        {messages.xeroDisconnected}
                    </Text>
                </Flex>
            </Flex>
        </Box>
    );
};

XeroIntegrationDisconnectedNotice.displayName = 'XeroIntegrationDisconnectedNotice';
